"use client";

import { ArrowDown, CalendarDays } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RServerUneInspection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="8" id="réserver-une-inspection" className="dark bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694820/img/drain_camera_inspection_technician.png)]" aria-hidden="true" />
      {}
      <div className="absolute inset-0 bg-background/70 backdrop-blur-[2px]" aria-hidden="true" />

      {}
      <span className="hidden lg:block absolute left-6 xl:left-12 top-1/2 -translate-y-1/2 font-serif italic text-primary/40 text-2xl xl:text-3xl rotate-[-8deg] select-none" aria-hidden="true">
        précision chirurgicale
      </span>
      <span className="hidden lg:block absolute right-6 xl:right-12 top-1/2 -translate-y-1/2 font-serif italic text-primary/40 text-2xl xl:text-3xl rotate-[8deg] select-none" aria-hidden="true">
        expertise technique
      </span>

      {}
      <div ref={ref} className={`relative z-10 min-h-[480px] flex flex-col items-center justify-center px-6 py-20 md:py-24 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="max-w-[800px] mx-auto text-center flex flex-col items-center gap-6 md:gap-8">
          <Badge variant="secondary" className="bg-primary text-primary-foreground border-transparent rounded-md px-4 py-1.5 text-xs tracking-[0.2em] uppercase font-mono">
            Disponibilité Immédiate
          </Badge>

          <h2 className="font-serif font-default text-foreground leading-[1.1] tracking-tight" style={{
          fontSize: "clamp(2.5rem, 6vw, 4rem)"
        }}>
            [02] L'inspection commence
            <br />
            par une <em className="italic font-light text-primary">clarté totale.</em>
          </h2>

          <p className="text-foreground/80 text-base md:text-lg max-w-xl leading-relaxed font-default">
            Identifiez la source exacte de vos problèmes de drainage avec notre technologie de pointe. 
            Des solutions durables à partir de 275$.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 items-center justify-center w-full sm:w-auto pt-2">
            <Button size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 rounded-md px-7 py-6 h-auto text-sm font-medium tracking-wide w-full sm:w-auto shadow-lg" asChild>
              <Link to="/ContactPage">
                <CalendarDays className="size-4" />
                Réserver une Inspection
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="bg-transparent border-primary/40 text-foreground hover:bg-primary/10 hover:text-foreground rounded-md px-7 py-6 h-auto text-sm font-medium tracking-wide w-full sm:w-auto" asChild>
              <Link to="/UncloggingPage">
                Débouchage de Drain
                <ArrowDown className="size-4" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="relative w-full max-w-4xl mx-auto mt-14 md:mt-20 pt-8 border-t border-border/30">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-foreground/60 text-[10px] sm:text-xs tracking-[0.18em] uppercase font-mono text-center">
            <span>À partir de 275$ · Équipement Pro</span>
            <span className="hidden sm:inline text-primary/50">·</span>
            <span>Urgence 24/7 Montréal & Rives</span>
            <span className="hidden sm:inline text-primary/50">·</span>
            <span>Rapport Vidéo Inclus</span>
          </div>
        </div>
      </div>
    </section>;
}